import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {selectOption} from '../../actionCreators/selectOption';
import RomanianPackage from '../../languages/RomanianPackage';
import checkProperRole from '../../utils/checkProperRole'
import './Sidemenu.css';

class Submenu extends React.Component {

    constructor () {

        super();

        this.state = {
            hidden: true
        }
    }

    createSubmenu(option) {

        if (option.subitems) {
            return option.subitems.map((subitem)=>{

                var permission = checkProperRole(this.props.userRoles, subitem.role);
                
                    return(
                        <li 
                            key = {subitem.id}
                            onClick = {() => this.props.selectOption(subitem)}
                            className = {permission ? (this.props.view && this.props.view.defaultName === subitem.defaultName ? 'active' : '') : 'hide' }
                        >
                            {RomanianPackage[subitem.defaultName]}
                        </li>
                    )
            })
        }
    }

    toggle(){

        this.setState({hidden: !this.state.hidden})
    }   

    render() {

        return (
            <ul className = {this.props.permission ? 'show' : 'hide'}>
                <li 
                    onClick={() => this.toggle()}
                >
                    {this.props.option.icon} {RomanianPackage[this.props.option.defaultName]}
                </li>
                <ul className = 'submenu' hidden = {this.state.hidden}>
                    {this.createSubmenu(this.props.option)}
                </ul>
            </ul>
        )
    }
}

function mapStateToProps(state) {
    return {
        
        view: state.activeOption,
        userRoles: state.userRoles
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        selectOption: selectOption,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(Submenu);


// WEBPACK FOOTER //
// ./src/containers/sidemenu/Submenu.js